import React from 'react';
import { VehicleParameters } from './VehicleParameters/VehicleParameters';
import { CarMainImage } from './CarMainImage/CarMainImage';
import SectionSubtitle from '@/components/Typography/SectionSubtitle';
import { CarParameters } from './CarParameters/CarParameters';
import type { PhotoGalleryItem } from '@/components/PhotoGallery/PhotoGallery.types';

interface RaportMainParamsProps {
  mainPhotoUrl?: string;
  mainPhoto?: PhotoGalleryItem;
  vehicleData: {
    brand: string;
    model: string;
    productionYear: string;
    vin: string;
    mileage: string;
    countryOfOrigin: string;
    fuelType: string;
    engineDisplacement: string;
    enginePower: string;
    driveType: string;
    engineLayout: string;
    transmission: string;
    bodyType: string;
    doorCount: string;
    color: string;
    maxWeight: string;
    registrationNumber: string | null;
    insuranceExpiryDate: string | null;
    firstRegistrationDate: string | null;
    nextTechnicalInspectionDate?: string | null;
    firstRegistrationInPoland?: string | null;
    isRegistrationNumberConsistent?: string | null;
  };
}

export const RaportMainParams: React.FC<RaportMainParamsProps> = ({
  vehicleData,
  mainPhotoUrl,
  mainPhoto,
}) => {
  return (
    <div className="w-full-6 pt-[58px]">
      <div className="flex flex-col-reverse gap-8 items-start lg:flex-row">
        <div className="w-full lg:w-[65%]">
          <VehicleParameters vehicleData={vehicleData} />
        </div>

        <div className="w-full lg:w-[35%]">
          <CarMainImage
            make={vehicleData.brand}
            model={vehicleData.model}
            imageUrl={mainPhotoUrl || ''}
            mainPhoto={mainPhoto}
          />
        </div>
      </div>

      <div className="mt-[76px]">
        <SectionSubtitle title="Dane pobrane z dokumentacji pojazdu" />
        <div className="mt-6">
          <CarParameters
            parameters={[
              {
                label: 'Numer rejestracyjny auta:',
                value: vehicleData.registrationNumber,
              },
              {
                label: 'Data ważności ubezpieczenia:',
                value: vehicleData.insuranceExpiryDate,
              },
              {
                label: 'Data pierwszej rejestracji:',
                value: vehicleData.firstRegistrationDate,
              },
            ]}
          />
          <CarParameters
            parameters={[
              {
                label: 'Data następnego przeglądu technicznego:',
                value: vehicleData.nextTechnicalInspectionDate || null,
              },
              {
                label: 'Data pierwszej rejestracji w Polsce:',
                value: vehicleData.firstRegistrationInPoland || null,
              },
              {
                label: 'Czy numer VIN jest zgodny z dokumentami?',
                value: vehicleData.isRegistrationNumberConsistent || null,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};
